import React, { useState } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { withRouter } from "react-router";
import axiosInstance from "../../utils/axiosInstance";
import logo from "../../assets/images/logo-sm.svg";
import { useHistory } from "react-router";
import ButtonBasic from "../../components/Buttons/ButtonBasic";
import LoaderComponent from "../../components/Spinner/LoaderComponent";
import queryString from "query-string";
import DibLogo from "../../assets/images/logos/dibLogo.png";
import McbLogo from "../../assets/images/logos/mcb-logo.svg";
import Toast from "../../components/Toast/Toast";

const resetSchema = Yup.object().shape({
  otpValue: Yup.string().required(),
});

const ResetTwoFactorAuth = (props) => {
  const history = useHistory();
  let params = queryString.parse(props.location?.search);
  const [resetError, setResetError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const reset2fa = async (values) => {
    setIsLoading(true);

    try {
      const res = await axiosInstance.post(
        `/users/validate-2fa-otp?token=${encodeURIComponent(params?.token)}&otpValue=${values?.otpValue}`
      );

      const { message, data } = res;

      if (message?.status !== "200") {
        setResetError(message?.status);
        Toast(message?.description, "error");
        return;
      }

      setIsLoading(false);
      Toast(message?.description, "success");

      if (data && data?.twoFactorAuthData?.twoFactorAuthEnabled) {
        history.push("/2fa-setup", {
          twoFactorAuthData: data.twoFactorAuthData,
        });
      } else {
        history?.push("/login");
      }
    } catch (error) {
      setIsLoading(false);
      const errorMsg = error?.response?.data?.message?.description;
      setResetError(errorMsg);
      Toast(errorMsg, "error");
    }
  };

  // Get the logoType from localStorage, fallback to the state
  const logoTypeFromLocalStorage = localStorage.getItem("landingPageLogo");
  return (
    <>
      {isLoading && (
        <div
          className="spinner-center"
          style={{ top: "0%", left: "0%", zIndex: 2000 }}
        >
          <LoaderComponent />
        </div>
      )}
      <div className="auth-container">
        <div className="d-flex align-items-center justify-content-center brand-name-wrapper">
          <img
            className="mt-5"
            src={
              logoTypeFromLocalStorage === "dib"
                ? DibLogo
                : logoTypeFromLocalStorage === "MCB"
                ? McbLogo
                : logo
            }
            alt="Logo"
            width={
              logoTypeFromLocalStorage === "MCB"
                ? "10%"
                : logoTypeFromLocalStorage === "dib"
                ? "15%"
                : "10%"
            }
          />
        </div>
        <div
          id="login"
          className="d-flex justify-content-center align-items-center"
          style={{ height: "80vh" }}
        >
          <div className="card auth-card">
            <div className="card-body">
              <h3 className="text-center text-dark pt-5 font-weight-bold">
                Reset 2FA
              </h3>
              <div className="container mt-3">
                <div
                  id="login-row"
                  className="row justify-content-center align-items-center"
                >
                  <div id="login-column" className="col-md-12">
                    <div id="login-box" className="col-md-12">
                      <Formik
                        initialValues={{
                          otpValue: "",
                        }}
                        validationSchema={resetSchema}
                        onSubmit={(values, { resetForm }) => {
                          reset2fa(values);
                        }}
                        onReset={({ resetForm }) => resetForm()}
                      >
                        {({ errors, touched, handleSubmit, handleReset }) => (
                          <Form
                            id="reset-2fa-form"
                            className="form"
                            onSubmit={handleSubmit}
                            onReset={handleReset}
                          >
                            <div className="form-group">
                              <label htmlFor="OTPValue" className="text-info">
                                OTP:
                              </label>
                              <br />
                              <Field
                                type="text"
                                name="otpValue"
                                id="otpValue"
                                placeholder="123-123"
                                className="form-control rs-input"
                                style={{ borderRadius: "10px" }}
                                autoComplete="off"
                              />
                              {errors.otpValue && touched.otpValue ? (
                                <div className="field-error">
                                  {errors.otpValue}
                                </div>
                              ) : null}
                            </div>
                            <div className="form-group">
                              <br />
                              <ButtonBasic
                                id="reset-2fa-button"
                                type="submit"
                                classes={"primary px-4 w-100"}
                                title={"Reset 2FA"}
                                onClick={handleSubmit}
                              />
                            </div>
                          </Form>
                        )}
                      </Formik>
                      {resetError && (
                        <div className="alert alert-danger" role="alert">
                          {resetError}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(ResetTwoFactorAuth);
